export const faceImage=require('../assets/blck.png')
export const checkboxImage=require('../assets/checkbox.png')
export const lightThemeBg=require('../assets/lightBg.png')
export const darkThemeBg=require('../assets/darkBg.png')
export const arrowLogo=require('../assets/arrowLogo.png')
export const faceLight=require('../assets/lit.png')
export const view=require('../assets/view_.svg')
export const darkView=require('../assets/dark_view.svg')
export const RightIcon=require('../assets/RightIcon.svg')